module.exports = __webpack_public_path__ + "static/media/INJ-BNB.e6f5f5a4.svg";